export const zhCNContent = {
  introduction: {
    content: [
      "自1996年首次亮相以来，宝可梦系列就俘获了全球玩家的心，成为了全世界最受欢迎的娱乐品牌之一。我们的随机宝可梦生成器专为各个年龄段的训练家设计，无论是想要发现新的宝可梦、组建平衡的队伍，还是想在宝可梦之旅中享受惊喜，都能满足您的需求。",
      "无论您是在为下一场比赛寻找灵感的资深竞技玩家，还是想要扩充图鉴的休闲玩家，这个宝可梦随机生成工具都能为您提供一个有趣且互动的方式来探索广阔的宝可梦世界。"
    ]
  },
  howToUse: {
    content: [
      "使用我们的随机宝可梦选择器简单直观。按照以下步骤开始生成您的完美宝可梦队伍：",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "选择宝可梦数量：决定要生成多少只宝可梦（1-8只）。" },
          { type: "text", content: "选择属性：可以筛选特定的宝可梦属性，如火属性、水属性、电属性等，也可以选择\"任意\"来包含所有属性。" },
          { type: "text", content: "选择世代：可以选择从第一世代到第八世代，或选择\"任意\"来包含所有世代的宝可梦。" },
          { type: "text", content: "设置稀有度：决定生成的宝可梦的稀有程度。" },
          { type: "text", content: "点击\"生成\"：设置好偏好后，点击按钮生成符合条件的宝可梦。" },
          { type: "text", content: "探索结果：查看每只宝可梦的详细信息，包括种族值、特性、属性等更多信息！" }
        ]
      },
      "您可以随时调整参数，多次尝试以发现不同的宝可梦组合。"
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "完全免费：我们的随机宝可梦生成器完全免费使用，没有隐藏费用或订阅要求。" },
          { type: "text", content: "自定义体验：可以通过属性、世代和稀有度来定制您的随机选择。" },
          { type: "text", content: "教育工具：了解不同宝可梦的种族值、特性和属性。" },
          { type: "text", content: "组队助手：快速生成适合休闲对战或竞技对战的平衡队伍。" },
          { type: "text", content: "挑战创造器：通过限制使用随机生成的宝可梦来创造独特的游戏挑战。" },
          { type: "text", content: "无需账号：无需注册或提供个人信息，即可立即使用工具。" }
        ]
      }
    ]
  },
  history: {
    content: [
      "宝可梦系列始于1996年，当时田尻智创造了第一款适用于任天堂Game Boy的宝可梦游戏。受到田尻智童年时期收集昆虫爱好的启发，这个概念围绕着捕捉、训练和与被称为\"口袋妖怪\"（Pocket Monsters）或宝可梦的生物对战展开。",
      "宝可梦历史上的重要里程碑包括：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996年：在日本发行原版《宝可梦 红·绿》" },
          { type: "text", content: "1998年：在国际市场发行《宝可梦 红·蓝》" },
          { type: "text", content: "1999年：在全球推出宝可梦集换式卡牌游戏" },
          { type: "text", content: "2000年：推出《宝可梦 金·银》，增加了100只新宝可梦" },
          { type: "text", content: "2016年：发布《Pokémon GO》，将系列带入移动平台" },
          { type: "text", content: "2019年：在任天堂Switch平台推出《宝可梦 剑·盾》" }
        ]
      },
      "如今，随着八个世代超过900只不同的宝可梦，该系列已扩展到包括电子游戏、集换式卡牌、动画系列、电影、周边商品和移动应用程序，成为了有史以来最高收入的媒体品牌之一。"
    ]
  },
  popularPokemon: {
    content: [
      "在宝可梦的历史中，一些宝可梦已成为了系列的标志性象征：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "皮卡丘：系列的电属性吉祥物，以其闪电形状的尾巴和红润的脸颊而闻名。" },
          { type: "text", content: "喷火龙：深受粉丝喜爱的火属性/飞行属性宝可梦，以其类似龙的外形和强大的能力而著名。" },
          { type: "text", content: "超梦：通过对梦幻的基因操作而创造的传说中的超能力属性宝可梦，以其强大的力量而闻名。" },
          { type: "text", content: "伊布：因其独特的进化能力而备受喜爱，可以进化为水伊布、雷伊布和火伊布等多种形态。" },
          { type: "text", content: "暴鲤龙：从弱小的鲤鱼王进化而来的威猛水属性/飞行属性宝可梦。" },
          { type: "text", content: "路卡利欧：以其波导之力和在竞技对战中的人气而闻名的格斗属性/钢属性宝可梦。" },
          { type: "text", content: "甲贺忍蛙：通过动画系列而广受欢迎的水属性/恶属性忍者蛙宝可梦。" }
        ]
      },
      "我们的随机宝可梦生成器让您有机会发现这些标志性的宝可梦，以及许多其他同样引人入胜但较少人知道的物种。"
    ]
  },
  popularGames: {
    content: [
      "宝可梦游戏系列在多个平台上推出了众多深受欢迎的作品：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "《宝可梦 红·蓝·黄》：在Game Boy平台上开创系列传奇的原始游戏。" },
          { type: "text", content: "《宝可梦 金·银·水晶》：引入了城都地区和昼夜交替系统。" },
          { type: "text", content: "《宝可梦 红宝石·蓝宝石·绿宝石》：通过丰缘地区和双打对战扩展了游戏世界。" },
          { type: "text", content: "《宝可梦 钻石·珍珠·白金》：将系列带入任天堂DS平台，引入在线功能。" },
          { type: "text", content: "《宝可梦 黑·白》：推出全新的宝可梦阵容，着重于故事剧情。" },
          { type: "text", content: "《宝可梦 X·Y》：引入3D模型和超级进化。" },
          { type: "text", content: "《宝可梦 太阳·月亮》：用岛屿试炼重新诠释道馆系统。" },
          { type: "text", content: "《Pokémon GO》：成为全球现象的增强现实移动游戏。" },
          { type: "text", content: "《宝可梦 剑·盾》：将系列带入任天堂Switch平台，引入了旷野地带概念。" },
          { type: "text", content: "《宝可梦传说 阿尔宙斯》：系列首次尝试开放世界玩法。" }
        ]
      },
      "每款游戏都引入了新的机制和宝可梦，扩展了可以通过我们的随机宝可梦生成器探索的宝可梦世界。"
    ]
  },
  tradingContests: {
    content: [
      "交换宝可梦自系列诞生以来就是其基本特色。最初的游戏就是成对发行，专门鼓励玩家与朋友交换宝可梦来完成图鉴。这种社交元素帮助传播了宝可梦的人气，至今仍然重要。",
      "交换的关键特点包括：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "版本专属宝可梦，只能通过交换获得" },
          { type: "text", content: "某些宝可梦如勇基拉和怪力需要通过交换才能进化" },
          { type: "text", content: "现代游戏中的全球交换系统（GTS）允许全球范围的交换" },
          { type: "text", content: "作为身份象征的稀有或闪光宝可梦交换" }
        ]
      },
      "在第三世代引入的宝可梦华丽大赛提供了一种与对战不同的竞争方式，宝可梦根据外表、表现和魅力而不是战斗力来竞争。这些比赛包括：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "不同的华丽大赛类别（帅气、美丽、可爱、聪明、强壮）" },
          { type: "text", content: "专门为华丽大赛设计的招式" },
          { type: "text", content: "通过树果和宝芬管理宝可梦状态" },
          { type: "text", content: "包含初步视觉评判和表演回合的多阶段比赛" }
        ]
      },
      "我们的随机宝可梦生成器可以帮助您发现在华丽大赛中表现出色或成为有价值的交换伙伴的宝可梦，为您的宝可梦体验增添新的维度。"
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "这个随机宝可梦生成器是免费的吗？",
            answer: "是的，我们的工具完全免费，没有任何隐藏费用或订阅要求。"
          },
          {
            type: "faq",
            question: "宝可梦数据的准确性如何？",
            answer: "所有宝可梦数据都来自官方PokéAPI，确保准确性和及时更新。"
          },
          {
            type: "faq",
            question: "我可以生成特定世代的宝可梦吗？",
            answer: "是的，您可以选择从第一世代到第八世代的任何世代，或选择\"任意\"来包含所有世代。"
          },
          {
            type: "faq",
            question: "稀有度筛选器是如何工作的？",
            answer: "我们的算法根据传说/神话身份、基础经验值等因素，为每只宝可梦分配1-10的稀有度值。"
          },
          {
            type: "faq",
            question: "我可以保存或导出生成的宝可梦吗？",
            answer: "目前，您可以截图保存结果。我们正在考虑在未来更新中添加保存/导出功能。"
          },
          {
            type: "faq",
            question: "随机宝可梦生成器支持移动设备吗？",
            answer: "是的，我们的生成器完全支持响应式设计，可以在智能手机、平板电脑和台式电脑上使用。"
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "我们的随机宝可梦生成器为休闲玩家和专业训练师提供了无限可能。无论您是想发现新的最爱、创建主题团队，还是通过意外组合挑战自己，我们的工具都提供了一种有趣且具教育意义的方式来探索广阔的宝可梦世界。",
      "我们不断努力添加新功能和选项来改进生成器。立即设置您的偏好并点击\"生成\"，看看有哪些宝可梦等着您！",
      "与朋友和其他训练师分享您的结果，告诉我们您如何在宝可梦之旅中使用随机宝可梦生成器。祝您探索愉快！"
    ]
  },
  // "我像哪个宝可梦？"内容部分
  whichPokemonIntro: {
    content: [
      "您是否曾经想知道自己最像哪个宝可梦？我们的\"我像哪个宝可梦？\"工具提供了一种有趣且独特的方式，让您根据自己的身体特征发现宝可梦分身。",
      "这个创新功能会分析您的身高和体重，识别出与您体型最接近的宝可梦。无论您是如喷火龙般高大，还是如皮卡丘般紧凑，我们的算法都能以惊人的准确度找到您完美的宝可梦匹配。"
    ]
  },
  whichPokemonHowToUse: {
    content: [
      "使用我们的\"我像哪个宝可梦？\"工具非常简单，只需几秒钟。请按照以下简单步骤发现您的宝可梦匹配：",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "在提供的表格中输入您的名字（或昵称）。" },
          { type: "text", content: "以厘米（cm）输入您的身高。" },
          { type: "text", content: "以公斤（kg）输入您的体重。" },
          { type: "text", content: "点击\"查找我的宝可梦\"按钮查看结果。" },
          { type: "text", content: "查看匹配的宝可梦，包括名称、类型、体型、重量和相似度分数。" },
          { type: "text", content: "在社交媒体上分享您的结果，或下载为图片展示给朋友！" }
        ]
      },
      "相似度分数表示您的身体比例与宝可梦的接近程度。百分比越高，匹配度越接近！"
    ]
  },
  whichPokemonBenefits: {
    content: [
      "发现您的宝可梦分身不仅仅是娱乐价值：",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "有趣的学习方法：发现并学习与您身体特征匹配的新宝可梦。" },
          { type: "text", content: "独特视角：通过宝可梦世界的视角看待自己。" },
          { type: "text", content: "对话起点：与朋友分享结果，比较每个人匹配哪个宝可梦。" },
          { type: "text", content: "角色扮演灵感：为角色扮演找到自然适合您体型的宝可梦。" },
          { type: "text", content: "组建团队：在宝可梦游戏中基于您和朋友们的身体相似性创建主题团队。" }
        ]
      }
    ]
  },
  whichPokemonFAQ: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "匹配算法有多准确？",
            answer: "我们的算法使用来自PokéAPI的官方宝可梦尺寸和重量数据，并基于比例欧几里得距离计算相似性。虽然它设计更注重趣味性而非科学精确性，但许多用户发现匹配结果惊人地合适！"
          },
          {
            type: "faq",
            question: "为什么工具不考虑其他身体特征？",
            answer: "目前，我们专注于身高和体重是为了简单起见，也因为这些是所有宝可梦物种中最一致记录的物理属性。我们可能会在未来更新中添加更多属性。"
          },
          {
            type: "faq",
            question: "我可以匹配任何宝可梦吗？",
            answer: "目前，为了优化性能，工具只匹配原始151只宝可梦（第一世代）。我们计划在未来更新中扩展，包括所有世代。"
          },
          {
            type: "faq",
            question: "我的个人数据会被存储或共享吗？",
            answer: "不会，我们不存储您输入的身高、体重或其他个人信息。所有计算都在您的浏览器中进行，不会发送任何内容到我们的服务器。"
          },
          {
            type: "faq",
            question: "为什么我和有类似测量值的朋友匹配到不同的宝可梦？",
            answer: "身高与体重比例的细微差异可能导致不同的匹配。算法考虑的是比例而非绝对值。"
          },
          {
            type: "faq",
            question: "我可以在社交媒体上分享我的结果吗？",
            answer: "是的！您可以将结果下载为图片，或使用提供的按钮直接分享到微博和微信等平台。"
          }
        ]
      }
    ]
  },
  whichPokemonConclusion: {
    content: [
      "我们的\"我像哪个宝可梦？\"工具提供了关于您在奇妙宝可梦世界中可能存在方式的有趣见解。虽然主要设计用于娱乐，但许多用户发现，除了单纯的身体相似性外，他们与匹配宝可梦的性格或能力有着令人惊讶的联系。",
      "尝试稍微调整您的输入，看看不同的身高和体重如何影响您的匹配，或挑战朋友和家人找出他们的宝可梦分身。您可能会对产生的宝可梦配对感到惊讶！",
      "无论您是匹配到雄伟的传说宝可梦、强大的初始宝可梦，还是被低估的口袋妖怪，都要拥抱您的宝可梦分身和您共享的独特特质。毕竟，在宝可梦世界中，每个物种都有其独特的优势和意义。"
    ]
  }
}; 